<template>
    <v-layout row wrap class="pt-2">
        <v-flex md3 id="select">
            <QuickInformationForm/>
        </v-flex>
        <v-flex sm7 md9 id="select">
            <BankStatementInformationTable/>
            <FcsMcaInformationTable/>
            <SingleMcaInformationTable/>
        </v-flex>
    </v-layout>
</template>

<script>
import QuickInformationForm from './QuickInformationForm'
import BankStatementInformationTable from './BankStatementInformationTable'
import FcsMcaInformationTable from './FcsMcaInformationTable'
import SingleMcaInformationTable from './SingleMcaInformationTable'
export default {
    components :{
        QuickInformationForm,
        BankStatementInformationTable,
        FcsMcaInformationTable,
        SingleMcaInformationTable
    }
}
</script>